import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
var _Input = function (props) {
    return (_jsx("input", { onChange: props.changeAmount, disabled: props.freebetToggled, type: 'tel', pattern: '[0-9]*', maxLength: '7', placeholder: props.placeholder || '', className: "bet ".concat(props.error && props.error !== 6 ? 'error' : ''), value: props.couponAmount }));
};
_Input.propTypes = {
    freebetToggled: PropTypes.bool.isRequired,
    couponAmount: PropTypes.any.isRequired,
    changeAmount: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    error: PropTypes.number
};
export default _Input;



// WEBPACK FOOTER //
// ./src/components/coupon/betTypesComponents/_Input.jsx